import React, { use, useEffect } from "react";
import { QuestionIcon } from "../Icons";
import { getBlogsComments } from "@/requests/product";
import { removeZone } from "@/utils";

export default function CommentSection({
  data,
  handleAddComment,
}: {
  data: any;
  handleAddComment: () => void;
}) {
  const [commentData, setCommentData] = React.useState<any>();

  useEffect(() => {
    const fetchCommentData = async () => {
      getBlogsComments(data?.id, 1, 5).then((res) => {
        // console.log("Comment Data:", res);
        setCommentData(res.data);
      });
    };
    fetchCommentData();
  }, [data]);

  return (
    <div className="pt-6">
      <div className="border-b border-gray-300 pb-2 flex justify-between">
        <h3 className="text-xl font-semibold text-primary">Comment</h3>

        <button
          className="bg-primary/10 text-primary px-3 py-1 rounded"
          onClick={handleAddComment}
        >
          Comment Now
        </button>
      </div>

      <div className="">
        {commentData?.map((comment: any) => {
          return comment?.status === "active" ? (
            <div
              key={`${comment?.id || comment?.comment_id}-comment`}
              className="my-3 space-y-2 border-b border-b-gray-300 pb-3"
            >
              <p>
                <span className="text-lg font-medium">
                  {comment?.user_name || "Anonymous User"}{" "}
                </span>
                <span className="text-sm text-gray-500">
                  on{" "}
                  {new Date(
                    removeZone(comment?.created_at || "")
                  ).toLocaleString()}
                </span>
              </p>

              <div className="space-y-2 text-sm">
                <div className="font-medium">
                  <span className="">Comment: </span>
                  {comment?.comment_content}
                </div>

                <div>
                  <span className="font-medium">Reply: </span>
                  {comment?.reply_content || "No reply yet"}
                </div>
              </div>
            </div>
          ) : null;
        })}
      </div>
      {commentData && commentData?.length === 0 && (
        <div className="flex flex-col justify-center items-center my-8">
          <QuestionIcon width={64} height={64} />
          <p className="text-lg mt-6 mb-2">No Comment Found</p>
          <button
            className="bg-primary/10 text-primary px-3 py-1 rounded"
            onClick={handleAddComment}
          >
            Be the first to comment
          </button>
        </div>
      )}
    </div>
  );
}
